import sanitizeHtml from 'sanitize-html';

const BLOCK_TAG_PATTERN =
  /<\/?(?:p|div|h[1-6]|li|br|tr|td|th|blockquote|section|article|header|footer|title|head|body)[^>]*>/gi;

/**
 * Converts HTML to plain text by stripping all tags. Uses sanitize-html so it
 * handles nested tags and malformed HTML correctly in both browser and SSR.
 * Block-level tags are replaced with spaces first so adjacent text nodes do not
 * run together. Output may still contain HTML entity references (e.g. &amp;)
 * due to sanitize-html's escaping; decode separately if needed.
 */
export function htmlToPlainText(html: string): string {
  if (!html?.trim()) return '';
  const withBlockBreaks = html.replace(BLOCK_TAG_PATTERN, ' ');
  const text = sanitizeHtml(withBlockBreaks, { allowedTags: [] });
  return text.replace(/\s+/g, ' ').trim();
}

/**
 * True when `html` renders any visible text once tags, entities and whitespace
 * are stripped. Rich-text editors serialise a cleared field to markup like
 * `<p></p>`, `<p><br></p>` or `<p>&nbsp;</p>`, all truthy strings that render
 * nothing, so a bare `Boolean(html)` check wrongly reports "has text". This
 * decodes entities (named and numeric) via sanitize-html, so `&nbsp;`, `&#160;`
 * and friends all collapse to empty.
 */
export function hasVisibleText(html: string | null | undefined): boolean {
  return !!html && htmlToPlainText(html).length > 0;
}
